import React from "react";
import { AppInside } from "../pages/AppInside";
import { NewAccount } from "../pages/NewAccount";
import { Routes as Switch, Route, Navigate } from "react-router-dom";
import { InvitationSurveyQualitative } from "../pages/InvitationSurveyQualitative";

export const AuthRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path="register" element={<NewAccount />} />
      <Route path="app-inside" element={<AppInside />} />
      <Route path="survey" element={<AppInside />} />
      <Route path="invitation-survey-qualitative" element={<InvitationSurveyQualitative />} />
      <Route path="*" element={<Navigate to="/app-inside" />} />
    </Switch>
  );
};
